import styled, { useTheme } from 'styled-components';
import Modal, { FullHeightModalContent } from '../../../components/Modal';
import { BodyLarge, ParagraphLargeText } from '../../../components/Texts';
import Button from '../../../components/Button';
import { useDispatch } from 'react-redux';
import { openModal, closeModal } from '../../../redux/slices/modals';
import CloseIcon from '../../../assets/icons/close.svg?react';

const ContentContainer = styled.div`
  width: 100%;
  overflow: hidden;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 4px;
`;

const CloseContainer = styled.div`
  padding: 20px;
  border-radius: 100%;
  background-color: ${({ theme }) => theme.status.error.primary};
  margin-bottom: 16px;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-top: 16px;
  width: 100%;
`;

const PaymentFailedModal = ({ onClose }) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const handleTryAnotherProvider = () => {
    dispatch(closeModal());
    dispatch(openModal({ name: 'addFunds' }));
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal onClose={onClose}>
      <FullHeightModalContent>
        <ContentContainer>
          <CloseContainer>
            <CloseIcon
              width={24}
              height={24}
              color={theme.background.primary}
            />
          </CloseContainer>
          <ParagraphLargeText style={{ color: theme.text.title }}>
            Payment Failed
          </ParagraphLargeText>
          <BodyLarge style={{ color: theme.text.secondary }}>
            Please try again or use a different card
          </BodyLarge>
        </ContentContainer>
        <ButtonContainer style={{ marginTop: 'auto', marginBottom: '20px' }}>
          <Button onClick={handleTryAnotherProvider} fullWidth={true}>
            Try Another Provider
          </Button>
          <Button onClick={handleCancel} variant='secondary' fullWidth={true}>
            Cancel
          </Button>
        </ButtonContainer>
      </FullHeightModalContent>
    </Modal>
  );
};

export default PaymentFailedModal;
